import { NgModule } from '@angular/core';
import { GrainientBackgroundComponent } from './grainient-background.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        GrainientBackgroundComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        GrainientBackgroundComponent
    ]
})
export class NcGrainientBackgroundModule { }